import React from 'react';
import './WebsiteNotificationBar.css';

const WebsiteNotificationBar = ({ children, isOpen, toggle }) => {
  if (!isOpen) return null;

  return (
    <div className="website-notification-bar" role="status" aria-live="polite">
      <div className="website-notification-bar__message">
        <strong>{children}</strong>
      </div>
      {typeof toggle === 'function' && (
        <button
          type="button"
          className="website-notification-bar__close"
          aria-label="Close maintenance banner"
          title="Close"
          onClick={toggle}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default WebsiteNotificationBar;
